import {ChipItem} from '@mydocma/component-library/src/lib/chips/chip-item';

export interface CustomBaseValidationError {
    mydocmaCustomError?: string;
    mydocmaCustomErrorIcon?: string;
}

export interface CustomValidationError extends CustomBaseValidationError {
    mydocmaCustomEmailError?: string;
    mydocmaCustomTimeError?: string;
    mydocmaCustomMaxSizeTotalError?: {text: string, formattedMaxSize: string};
}


export const CHIP_LIST_ERROR_KEY = 'chipListError';

export interface ChipValidationError {
    invalidChip: ChipItem;
    validationError: string;
}

export interface ChipListValidationError extends CustomBaseValidationError {
    chipListError?: ChipValidationError[];
}
